/**
 * RPC messages.
 *
 * @copyright Realeyes OU. All rights reserved.
 */


/**
 * Message types.
 */
export const MESSAGE_TYPE_RESPONSE = 'response';
export const MESSAGE_TYPE_EVENT = 'event';
export const MESSAGE_TYPE_ERROR = 'error';
